import { isBlackFriday } from "../utils";

export const klaviyoFormIds = {
    registerLeadForm: 'RWCuxg',
    newsletterNoDiscount: 'RW7SPh',
    newsletterWithDiscount: 'S8A58k',
};

export const getNewsletterKlaviyoFormId = (): string => {
    if (isBlackFriday()) {
        return klaviyoFormIds.newsletterNoDiscount;
    } else {
        return klaviyoFormIds.newsletterWithDiscount;
    }
}